<template>
    <div class="row">

        <div class="col-md-4 col-12">
            <small id="LblDepartmentName">نام دپارتمان</small>
            <input type="text" class="form-control required" v-model="item.departmentName" placeholder="نــام دپارتمان" />
        </div>
        <div class="col-md-4 col-12">
            <small id="LblTblUserSupervisor">سرپرست</small>
            <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="getSupervisorId" :rownumintable="4"
                :defaultvalue="item.tblUserSupervisor" :action="'TblCombo/GettblGrp'" :method="'POST'"
                :ClassProps="'required'" :idinput="'UserId'" :keyItem="'UserId1'" :disabled="false"> </SearchableCombo>
        </div>
        <div class="col-md-4 col-12">
            <small id="LblTblUserAdmin">مدیر</small>
            <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="getAdminId" :rownumintable="3"
                :action="'TblCombo/GettblGrp'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId0'"
                :ClassProps="'required'" :defaultvalue="item.tblUserAdmin" :disabled="false"> </SearchableCombo>
        </div>
        <div class="col-md-4 col-12 d-none">
            <small id="LblMaxSupervisorAccept">سقف مرخصی</small>
            <input type="number" class="form-control required" dir="ltr" v-model="item.maxSupervisorAccept" />
        </div>

        <div class="col-md-4 col-12 mt-4">
            <button class="btn btn-success" @click="submit">ثـبـت</button>
        </div>

    </div>
</template>
<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
    components: { SearchableCombo },
    props: ['item'],
    data() {
        return {
            item: {}
        }
    },
    methods: {
        submit() {
            if (!this.$ValidForm(this.$route.name)) {
                return
            }
            this.$PostData_new("put", "AutomationDepartment", this.item).then((res) => {
                if (res.isSuccess) {
                    this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
                    this.$emit("Result", res.isSuccess)
                } else {
                    this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
                }
            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطا سمت سرور', 'error', 2000)
                console.error(err)
            })
        },
        getAdminId(data) {
            if (data.id != null) {
                this.item.TblUserAdmin = data.id
            }
        },

        getSupervisorId(data) {
            if (data.id != null) {
                this.item.TblUserSupervisor = data.id
            }
        }
    }

}
</script>